import * as React from "react";
import { classNames } from "react-extras";

interface IProps {
  children?: React.ReactNode;
  active?: boolean;
  striped?: boolean;
  type?: string;
  progress: string | number;
  slim?: boolean;
}

const ProgressBar = ({
  children,
  active,
  progress,
  striped,
  type,
  slim,
}: IProps) => (
  <div
    className={"progress"}
    style={{ height: slim ? "6px" : "20px", width: "100%" }}
  >
    <div
      className={classNames(
        "progress-bar",
        type ? `progress-bar-${type}` : "progress-bar-info",
        {
          "progress-bar-striped": striped,
          active,
        }
      )}
      style={{ width: `${progress || 0}%`, height: "100%", minWidth: "2em" }}
    >
      {children}
    </div>
  </div>
);

export default ProgressBar;



// WEBPACK FOOTER //
// ./app/javascript/components/core/ProgressBar.tsx